import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives } from "vue";
var _hoisted_1 = {
  "class": "email-to"
};
var _hoisted_2 = {
  "class": "text-sm font-medium text-ftext"
};
var _hoisted_3 = {
  "class": "chip email flex items-center"
};
var _hoisted_4 = {
  "class": "mx-1"
};
var _hoisted_5 = ["onClick"];
var _hoisted_6 = /*#__PURE__*/_createElementVNode("i", {
  "class": "fi-rs-cross-small"
}, null, -1);
var _hoisted_7 = [_hoisted_6];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("label", _hoisted_2, _toDisplayString($props.label), 1), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($data.inputArr, function (val, index) {
    return _openBlock(), _createElementBlock("div", _hoisted_3, [_createElementVNode("span", _hoisted_4, _toDisplayString(val), 1), _createElementVNode("button", {
      onClick: function onClick($event) {
        return $options.deleteTag(index);
      }
    }, _hoisted_7, 8, _hoisted_5)]);
  }), 256)), _withDirectives(_createElementVNode("input", {
    "class": "p-1 m-1 grow rounded-sm outline-none",
    "onUpdate:modelValue": _cache[0] || (_cache[0] = function ($event) {
      return $data.inputval = $event;
    }),
    onKeyup: [_cache[1] || (_cache[1] = _withKeys(function ($event) {
      return $options.addInput();
    }, ["enter"])), _cache[2] || (_cache[2] = _withKeys(function ($event) {
      return $options.addInput();
    }, [","])), _cache[3] || (_cache[3] = _withKeys(function ($event) {
      return $options.addInput();
    }, [";"]))],
    onBlur: _cache[4] || (_cache[4] = function ($event) {
      return $options.addInput();
    }),
    autofocus: ""
  }, null, 544), [[_vModelText, $data.inputval]])]);
}